import { Injectable } from '@angular/core';
import { getCorporatePartner } from '@com-delta-idp/mnx-capability-profile-selector-smart';
import { ICorporatePartner } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  MultiCitySearchCache,
  RetrieveSearch
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { take, tap } from 'rxjs/operators';
import { HeaderSlimDeepLinkBaseService } from './header-slim-deep-link-base.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderSlimDeepLinkService extends HeaderSlimDeepLinkBaseService {
  initializeDeepLinkValues(): ICorporatePartner {
    try {
      const vendor = this.getDeepLinkVendor();
      return getCorporatePartner(vendor || '');
    } catch (error) {
      this.loggingService.log(JSON.stringify(error));
      return getCorporatePartner('');
    }
  }

  processDeepLinkSlimNav(): boolean {
    const isDeepLinkProcess = this.commonService.getDeepLinkVendor() !== '';
    return !!this.deepLinkCacheKey && !!this.deepLinkXssid && isDeepLinkProcess;
  }

  handleDeepLinkWithoutCookie(
    tripType: string,
    callback: (response: MultiCitySearchCache) => void
  ): void {
    this.multiCityRecentSearchService
      .getMultiCityRecentSearches$({ cacheKey: this.deepLinkCacheKey })
      .pipe(
        take(1),
        tap((response: MultiCitySearchCache) => {
          if (Object.keys(response).length > 0) {
            callback(response);
          }
        })
      )
      .subscribe();
  }

  setRecentSearch(
    recentData: MultiCitySearchCache | RetrieveSearch | undefined,
    tripType: string,
    onSuccess: (response: RetrieveSearch[]) => void
  ): void {
    const postAndRetrieve$ = this.createPostAndRetrieveStream(recentData);

    postAndRetrieve$.pipe(take(1)).subscribe(
      (response: RetrieveSearch[]) => {
        if (response && response.length > 0) {
          onSuccess(response);
        }
      },
      (error) => {
        this.loggingService.log(error);
      }
    );
  }

  private getDeepLinkVendor(): string | null {
    const deepLinkVendor = this.commonService.getDeepLinkVendor();
    if (!deepLinkVendor) return null;

    this.setDeepLinkParams();

    if (this.deepLinkVendor === deepLinkVendor) {
      this.commonService.setDeepLinkVendorCookie(
        this.deepLinkVendor,
        this.deepLinkCacheKey
      );
      return this.deepLinkVendor;
    }

    return this.getCookieVendor(deepLinkVendor);
  }
}
